import Layout from '@layout/Index'

export const fair = [
  {
    path: '/fair',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import('./pages/FairTable.vue'),
        name: '活动管理',
        meta: {
          title: '活动管理',
        },
      },
      {
        path: 'form',
        component: () => import('./pages/FairForm.vue'),
        name: '活动添加',
        meta: {
          title: '活动添加',
        },
      },
      {
        path: 'view/:fairid',
        component: () => import('./pages/FairForm.vue'),
        name: '查看活动',
        meta: {
          title: '查看活动',
        },
      },
      {
        path: 'update/:fairid',
        component: () => import('./pages/FairForm.vue'),
        name: '活动编辑',
        meta: {
          title: '活动编辑',
        },
      },
      {
        path: 'remaining_prize_table/:fairid',
        component: () => import('./pages/FairRemainingPrizeTable.vue'),
        name: '转盘当天剩余奖品',
        meta: {
          title: '转盘当天剩余奖品',
        },
      },
      {
        path: 'user_limit_table/:fairid',
        component: () => import('./pages/FairRewardUserLimitTable.vue'),
        name: '转盘用户当天剩余次数',
        meta: {
          title: '转盘用户当天剩余次数',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/fair/fair.route.js